import { Injectable, computed, inject } from '@angular/core';
import { ENV_CONFIG } from '@core/config/env.token';

export type PhotoCaptureMode = 'single' | 'multi';

@Injectable({ providedIn: 'root' })
export class CapturePolicyService {
  private readonly config = inject(ENV_CONFIG);

  readonly mode = computed<PhotoCaptureMode>(() => {
    return this.config.photoCaptureMode === 'multi' ? 'multi' : 'single';
  });

  readonly maxPhotosPerRemito = computed(() => {
    const configured = this.config.maxPhotosPerRemito;
    if (typeof configured === 'number' && Number.isFinite(configured) && configured > 0) {
      return Math.max(1, Math.floor(configured));
    }

    return this.mode() === 'multi' ? 5 : 1;
  });

  readonly isSinglePhotoMode = computed(() => this.maxPhotosPerRemito() <= 1 || this.mode() === 'single');
  readonly isMultiPhotoMode = computed(() => !this.isSinglePhotoMode());
}
